export enum VertretungsBeziehungEnum {
    PERSON_VERTRETUNG = 'PERSON_VERTRETUNG',
    NICHT_RELEVANT = 'NICHT_RELEVANT',
}